export const HTTP_STATUS_CODE = {
  FORBIDDEN: '403',
  NOT_FOUND: '404',
  SUCCESS: '200'
};
